import styled from 'styled-components'
import { Container as Box } from '@material-ui/core'

export const Container = styled(Box)`
  .MuiExpansionPanel-root {
    border-top: 2px solid #ef4e45;
    box-shadow: none;
  }
`
